import React, { ReactElement } from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";

interface CBSamplesProps {
  sampleSelectedCallback?: (premise: string, hypothesis: string) => void;
}

const Samples = (props: CBSamplesProps): ReactElement => {
  const { sampleSelectedCallback } = props;

  const getLabelText = (label: string): string => {
    return label === "LABEL_0" ? "Entailment" : label === "LABEL_1" ? "Contradiction" : "Neutral";
  };

  const SAMPLES: { premise: string; hypothesis: string; label: string }[] = [
    { premise: "A diretora confirmou que a reunião acontecerá na sexta-feira.", hypothesis: "A reunião está marcada para sexta-feira.", label: "LABEL_0" },
    { premise: "João nunca visitou Lisboa.", hypothesis: "João já esteve em Lisboa.", label: "LABEL_1" },
    { premise: "Talvez a equipa apresente o relatório amanhã.", hypothesis: "A equipa apresentará o relatório amanhã.", label: "LABEL_2" },
    { premise: "Não acredito que a Maria tenha recusado o convite.", hypothesis: "A Maria recusou o convite.", label: "LABEL_2" },
    { premise: "O porta-voz negou que a empresa fosse encerrar a fábrica.", hypothesis: "A empresa vai encerrar a fábrica.", label: "LABEL_1" },
  ];

  return (
    <>
      {SAMPLES.map((sample, index) => {
        return (
          <Paper
            key={"sample-" + index}
            variant="elevation"
            elevation={4}
            sx={{
              padding: "8px",
              marginBottom: "10px",
              border: "1px solid",
              borderColor: "primary.light",
              backgroundColor: "background.paper",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease, transform 0.2s ease",
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-2px)",
              },
            }}
            onClick={() => {
              sampleSelectedCallback &&
                sampleSelectedCallback(sample.premise, sample.hypothesis);
            }}
          >
            <Stack spacing={1.5}>
              <Chip
                label={sample.label + " · " + getLabelText(sample.label)}
                color={sample.label === "LABEL_0" ? "success" : sample.label === "LABEL_1" ? "error" : "default"}
                variant={sample.label === "LABEL_0" ? "filled" : "outlined"}
                size="small"
                sx={{ alignSelf: "flex-start", fontWeight: 700 }}
              />
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Premise
                </Typography>
                <Typography variant="body2">{sample.premise}</Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Hypothesis
                </Typography>
                <Typography variant="body2">{sample.hypothesis}</Typography>
              </Box>
            </Stack>
          </Paper>
        );
      })}
    </>
  );
};

export default Samples;
